module.exports = __webpack_public_path__ + "static/img/girl-01.83964b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/album/girl-01.jpg
// module id = CgBb
// module chunks = 0